<template>
  <el-popover
    placement="right"
    trigger="hover"
    :visible-arrow="false"
    popper-class="related-company"
    @show="onShowEvidence(item.name)"
  >
    <div>
      <div class="evidence-loading" v-show="isLoading" v-loading="isLoading"></div>
      <div v-show="!isLoading">
        <div class="row related-company-header">
          <div class="related-company-name">{{item.stock_code}}</div> 
          <div class="row perimeter-companies-to-graph">
            <img class="arrow-right-up" src="../../assets/img/arrow-right-up.svg">
            <div class="perimeter-companies-to-graph-word" @click="toCompanyGraph(item.name, item.stock_code)">完整图谱</div>
          </div>
        </div>
        <div class="row perimeter-companies-tab">
          <div
            class="tab-item" 
            :class="{'tab-item-active': item === perimeterCompanySelectedOptionTab}" 
            v-for="(item, index) in perimeterCompanyTabs" 
            :key="index"
            @click="onPerimeterCompanyTabChange(item)"
            >
            {{item}}
          </div>
        </div>
        <div class="perimeter-content" v-if="perimeterAll.length">
          <div v-if="perimeterCompanySelectedOptionTab === '全部'">
            <div v-for="(item, index) in perimeterAll" :key="index">
              <div class="perimeter-name">{{item.relation}}</div>
              <div v-for="(i, idx) in item.related_companies" :key="idx">
                <div class="perimeter-company-name" @click="toCompanyDetail(i.name)">{{i.stock_code}}</div>
              </div>
            </div>
          </div>
          <div v-if="perimeterCompanySelectedOptionTab !== '全部'">
            <div v-for="(item, index) in perimeter" :key="index">
              <div class="perimeter-company-name" @click="toCompanyDetail(item.name)">{{item.stock_code}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="reference">
      <div class="img-slot" v-if="item.exist_related_company"></div>
    </span>
  </el-popover>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      perimeterCompanySelectedOptionTab: '全部',
      perimeterCompanyTabs: ['全部'],
      perimeterAll: [],
      perimeter: [],
      isLoading: false
    };
  },
  props: {
    item: {
      type: Object
    }
  },
  methods: {
    onShowEvidence(name) {
      this.perimeterAll = [];
      this.perimeterCompanyTabs = ['全部'];
      this.perimeterCompanySelectedOptionTab = '全部';
      this.isLoading = true;
      QuestionQuery.getRelatedCompanyEvidence(name).then(res => {
        this.isLoading = false;
        this.perimeterAll = res.relation_and_related_companies;
        let relationTitle = [];
        relationTitle = this.perimeterAll.map(item => item.relation);
        this.perimeterCompanyTabs = this.perimeterCompanyTabs.concat(relationTitle);
      });
    },
    toCompanyGraph(name, stockCode) {
      const routeUrl = this.$router.resolve({
        path: '/graph', 
        query: {
          id: name,
          label: stockCode
        }  
      });
      window.open(routeUrl.href, '_blank');
    },
    toCompanyDetail(q) {
      const routeUrl = this.$router.resolve({
        path: '/result', 
        query: {
          q
        }  
      });
      window.open(routeUrl.href, '_blank');
    },
    onPerimeterCompanyTabChange(res) {
      this.perimeterCompanySelectedOptionTab = res;
      if (this.perimeterCompanySelectedOptionTab !== '全部') {
        this.perimeter = this.perimeterAll.filter(item => item.relation === this.perimeterCompanySelectedOptionTab);
        this.perimeter = this.perimeter[0].related_companies;
      }
    }
  }
};
</script>

<style lang="scss">
.img-slot {
  margin-top: 3px;
  width: 16px;
  height: 16px;
  background: url("../../assets/img/related.svg") no-repeat;
  background-size: cover;
  cursor: pointer;
  &:hover{
    background: url("../../assets/img/related-hover.svg") no-repeat;
  }
}
  .el-popover.el-popper.related-company {
    padding: 0;
    width: 380px;
    height: 460px;
    background-color: #ffffff;
    box-shadow: 0px 8px 20px 0px rgba(0, 22, 144, 0.14);
    border-radius: 2px;
    .evidence-loading {
      height: 460px;
      width: 100%;
    }
    .related-company-header {
      justify-content: space-between;
      padding: 16px 24px;
      .related-company-name {
        width: 220px;
        color: #171f46;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .perimeter-companies-to-graph {
        cursor: pointer;
        .arrow-right-up {
          margin-top: 2px;
          height: 16px;
        }
        .perimeter-companies-to-graph-word {
          margin-left: 4px;
          color: #45a8cc;
          font-size: 14px;
        }
      }
    }
    .perimeter-companies-tab {
      flex-wrap: wrap;
      min-height: 28px;
      line-height: 28px;
      padding: 0 24px;
      border: 1px solid #f7f7fa;
      color: #9ea1b4;
      font-size: 12px;
      .tab-item {
        margin-right: 10px;
        flex-shrink: 0;
        cursor: pointer;
      }
      .tab-item-active {
        color: #45a8cc;
      }
    }
    .perimeter-content {
      padding: 8px 16px;
      height: 360px;
      overflow: auto;
      .perimeter-name {
        padding-left: 8px;
        margin-top: 10px;
        height: 28px;
        line-height: 28px;
        color:rgba(69,168,204,1);
        font-size: 12px;
      }
      .perimeter-company-name {
        padding: 5px 8px;
        color: #464D6C;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          background:rgba(247,248,252,1);
          font-weight: 500;
        }
      }
      .perimeter-company-name {
        padding: 5px 8px;
        color: #464D6C;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          background:rgba(247,248,252,1);
          font-weight: 500;
        }
      }
    }
    .check-atlas-btn {
      margin-top: 17px;
      height: 26px;
      width: 114px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #ffffff;
      background-color: #45a8cc;
      &:hover {
        color: #ffffff;
        background-color: #45a8cc;
      }
      &:focus {
        color: #ffffff;
        background-color: #45a8cc;
      }
      &:active {
        color: #ffffff;
        background-color: #45a8cc;
      }
    }
  }
</style>
